import PropTypes from 'prop-types';
import { useFormContext } from './context';
import './styles.less';
const {
  ControlGroup,
  Checkbox
} = svs.ui.reactForm;
const FormFieldOmbudType = ({
  isDisabled = false
}) => {
  const {
    formData,
    updateField,
    formErrors
  } = useFormContext();
  const ombudOptions = [{
    id: 'sellTypeCompleteRetailer',
    label: 'Spelombud',
    description: 'Spelombud säljer både turspel (som Triss, Lotto och Eurojackpot) och sportspel (som Stryktipset och Oddset).'
  }, {
    id: 'sellTypeTickets',
    label: 'Lottombud',
    description: 'Lottombud säljer enbart skraplotter – till exempel Triss.'
  }];
  const handleChange = (event, fieldId) => {
    updateField(fieldId, event.target.checked);
    if (fieldId === 'sellTypeCompleteRetailer' && event.target.checked) {
      updateField('sellTypeTickets', false);
    }
    if (fieldId === 'sellTypeTickets' && event.target.checked) {
      updateField('sellTypeCompleteRetailer', false);
    }
    if (event.target.checked) {
      updateField('ombudType', undefined);
    }
  };
  return <React.Fragment>
      <fieldset className={`form-fieldset padding-2 rounded-md ${formErrors.ombudType ? 'form-fieldset-error' : ''}`}>
        <h3 style={{
        fontWeight: 'bold',
        marginBottom: 0
      }}>
          Jag ansöker om att bli: *
        </h3>
        <span>Vänligen välj en av kryssrutorna nedan</span>

        <ControlGroup className="u-flex u-flex-column form-user-checkbox-column retailer-type margin-top-1" hasError={Boolean(formErrors.ombudType)}>
          {ombudOptions.map(({
          id,
          label,
          description
        }) => <label className="u-flex u-align-items-start margin-bottom-2" key={id} style={{
          textTransform: 'none',
          fontFamily: 'inherit',
          fontWeight: 'normal'
        }}>
              <Checkbox checked={Boolean(formData?.[id])} disabled={isDisabled} id={id} onChange={e => handleChange(e, id)} />
              <span className="padding-left-2">
                <strong>
                  {label}
                </strong>
                <br />
                <small>
                  {description}
                </small>
              </span>
            </label>)}
        </ControlGroup>
      </fieldset>
      {formErrors.ombudType && <div className="u-flex u-align-items-center margin-top-1">
          <i className="icon fc-red icon-200 icon-exclamation-sign" />
          <span className="text-red-500 text-sm margin-left-1">
            {formErrors.ombudType}
          </span>
        </div>}
    </React.Fragment>;
};
FormFieldOmbudType.propTypes = {
  isDisabled: PropTypes.bool
};
export default FormFieldOmbudType;